const React = require("react")
const Edit = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 2C0 0.89543 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V22C24 23.1046 23.1046 24 22 24H2C0.89543 24 0 23.1046 0 22V2Z"
        fill="#ECF0F1"
      />
      <path
        d="M3 17.4605V20.5005C3 20.7806 3.22 21.0005 3.5 21.0005H6.54C6.67 21.0005 6.8 20.9506 6.89 20.8505L17.81 9.94055L14.06 6.19055L3.15 17.1005C3.05 17.2005 3 17.3205 3 17.4605ZM20.71 7.04055C21.1 6.65055 21.1 6.02055 20.71 5.63055L18.37 3.29055C17.98 2.90055 17.35 2.90055 16.96 3.29055L15.13 5.12055L18.88 8.87055L20.71 7.04055Z"
        fill="#767474"
      />
    </svg>
  )
}

module.exports = {
  Edit
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/descriptionInvoiceHeader/edit.js